var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.$t('title'))}}),_vm._v(" "),_c('div',{staticClass:"customSelect"},_vm._l((_vm.existentLanguages),function(lang){return _c('span',{directives:[{name:"t",rawName:"v-t",value:(lang.name),expression:"lang.name"}],class:{active: _vm.selectedLanguage == lang.cod},on:{"click":function($event){_vm.changeLang(lang.cod)}}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f10f4eb6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguageSelector.vue
// module id = 102
// module chunks = 0